module.exports = __webpack_public_path__ + "img/2650088.3954ea39.png";